import RemoteStartInformation from 'src/components/ConnectedVehicle/RemoteStartInformation/RemoteStartInformation';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

export default connect(mapStateToProps)(RemoteStartInformation);